import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import * as S from './styles'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as DoctorIllustration } from 'presentation/assets/illustrations/doctor-orange.svg'
import { useMedia } from 'presentation/utils/window-media'
import HeaderNew from 'presentation/shared/components/HeaderNew'
import { observer } from 'mobx-react'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { toast } from 'react-toastify'
import { useServices } from 'presentation/hooks/use-services'
import { useStores } from 'presentation/hooks/use-stores'
import { DoctorDocument } from 'common/enum/doctor-document'
import downloadFileFromBlob from 'common/utils/downloadFileFromBlob'
import { getDocumentsLabelLocationByEnum } from 'presentation/utils/document-types-location'
import { Document } from 'domain/entities/document'

const SuccessAddSurgicalOrderLayout = WithLoading(
  observer(({ setIsLoading }: WithLoadingProps) => {
    const history = useHistory()
    const media = useMedia()
    const surgicalOrderService = useServices().surgicalOrder
    const store = useStores().surgicalOrderV2

    useEffect(() => {
      if (!store?.surgicalOrder?.surgicalOrderId) {
        toast.error('Ocorreu um erro ao carregar o planejamento cirúrgico')
        history.push('/home')
      }
    }, [store])

    const handleGoToDashboard = () => {
      history.push('/pedidos-cirurgicos/dashboard')
    }

    const handleScheduleSurgery = () => {
      history.push('/agendamento-cirurgico/inicio', {
        surgical_order_id: store.surgicalOrder.finalizedSurgicalOrderId
      })
    }

    const getSurgicalPlanning = async () => {
      try {
        setIsLoading(true)
        const surgicalOrder = await surgicalOrderService.getSurgicalOrderById({
          surgical_order_id: store.surgicalOrder.surgicalOrderId
        })
        const guides = surgicalOrder.documents?.filter(
          (document) => document.name === DoctorDocument.GUIDE_SURGICAL_PLANNING
        )

        if (guides && guides.length > 0) {
          const file: Document = guides[0]

          const surgicalPlanning =
            await surgicalOrderService.loadSurgicalOrderDocument({
              surgical_order_id: store.surgicalOrder.surgicalOrderId,
              document_id: file.document_id
            })

          if (surgicalPlanning) {
            downloadFileFromBlob(
              surgicalPlanning.data,
              surgicalPlanning.contentType,
              getDocumentsLabelLocationByEnum(file.name)
            )
            toast.success(
              'Download do planejamento cirúrgico concluído com sucesso'
            )
            history.push('/pedidos-cirurgicos/dashboard')
          } else {
            toast.warn('Ocorreu um erro ao baixar o planejamento cirúrgico')
          }
        } else {
          toast.warn(
            'A visualização do planejamento cirúrgico ainda não está disponível'
          )
        }
      } catch (error: any) {
        toast.error(error?.message)
      } finally {
        setIsLoading(false)
      }
    }

    return (
      <>
        <HeaderNew actualPageTitle="Pedido cirúrgico criado" showMenu />
        <ContainerNew>
          {store?.surgicalOrder?.surgicalOrderId && (
            <S.Wrapper>
              <S.TextWrapper>
                <HeadingNew
                  as="h1"
                  color="primary800"
                  size={media.sm ? 'xxlarge' : 'xlarge'}
                  flexStart
                  style={{ textAlign: 'start' }}
                >
                  Pedido cirúrgico enviado com sucesso
                </HeadingNew>

                <SupportTextNew
                  size={media.sm ? 'small' : 'xsmall'}
                  color="textPrimary"
                >
                  Seu pedido cirúrgico está em análise pelo hospital. De acordo
                  com a Agência Nacional de saúde Suplementar (ANS), o prazo de
                  autorização é de 21 dias úteis. Você pode ver atualizações
                  sobre o status de autorização do pedido na tela de Pedidos
                  Cirúrgicos.
                </SupportTextNew>
              </S.TextWrapper>

              <DoctorIllustration
                width={media.sm ? 360 : 240}
                height={media.sm ? 360 : 240}
              />

              <S.ButtonGroup>
                <ButtonNew size="large" onClick={handleGoToDashboard}>
                  Meus pedidos cirúrgicos
                </ButtonNew>
                <ButtonNew size="large" onClick={getSurgicalPlanning} outlined>
                  Visualizar planejamento cirúrgico
                </ButtonNew>
                <ButtonNew
                  size="large"
                  onClick={handleScheduleSurgery}
                  outlined
                  disabled={!store.surgicalOrder.finalizedSurgicalOrderId}
                >
                  Agendar cirurgia
                </ButtonNew>
              </S.ButtonGroup>
            </S.Wrapper>
          )}
        </ContainerNew>
      </>
    )
  })
)

export default SuccessAddSurgicalOrderLayout
